import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import Profiles from '@/views/profile/List.vue';

export const profilesRoute: RouteConfig = {
  path: '',
  name: 'profiles',
  component: Profiles,
  meta: { authorized: true },

  beforeEnter: (to: any, from: any, next: any) => {
    store
      .dispatch('profile/list')
      .then(() => next())
      .catch(() => store.dispatch('notifyError', { title: 'messages.profile.listError' }));
  }
};
